import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Grid, ResponsiveContext, Text } from "grommet";
import { first, orderBy, take } from "lodash";
import * as React from "react";
import Avatar from "react-avatar";
import { Link, useHref, useNavigate } from "react-router-dom";
import ScrollContainer from "../components/ScrollContainer";
import { RenderOutcome } from "../matches/OutcomeRenderer";
import { RenderWinner } from "./TournamentProfile";
import { TournamentParticipantViewModel, TournamentViewModel } from "./TournamentsStore";

export const TournamentRow = ({ tournament, children }: { tournament: TournamentViewModel; children: React.ReactElement }) => {
    let navigate = useNavigate();

    const size = React.useContext(ResponsiveContext);
    const linkProps = tournament.id ? { to: `/tournaments/${tournament.id}` } : { to: "" };

    return (
        <Link style={{ textDecoration: "none", color: "unset" }} {...linkProps}>
            <Box background={"background"} pad="small" hoverIndicator="background-back" onClick={() => {}}>
                <Grid columns={["130px", "200px", "auto"]} gap="small">
                    <Avatar name={tournament.name} round={"18px"} size="128px" src={tournament.logoUri}></Avatar>
                    <Box direction="row" align="center" gap="small">
                        <Box>
                            <Text weight={"bold"} style={{ textTransform: "uppercase" }}>
                                {tournament.name}
                            </Text>
                            <Text size="small"> {tournament.participants?.length || 0} participants</Text>
                        </Box>
                    </Box>

                    {size != "small" && tournament.bracket?.finals?.winner && (
                        <Box align="end">
                            <RenderWinner size={1} tournamentMatch={tournament.bracket?.finals}></RenderWinner>
                        </Box>
                    )}
                    {/* {size !== "small" && (
                        <ScrollContainer direction={"-x"}>
                            <Box direction="row" justify="end" fill gap="medium">
                                {tournament.participants?.map((participant) => (
                                    <Box direction="row" key={participant.id} align="center" gap="small" width={{ min: "70px" }}>
                                        {participant.team && (
                                            <Box align="center">
                                                <Avatar name={participant.team.name} round={"18px"} size="70" src={participant.team.logoUri}></Avatar>
                                                <Text>{participant.team.name}</Text>
                                            </Box>
                                        )}
                                    </Box>
                                ))}
                            </Box>
                        </ScrollContainer>
                    )} */}
                </Grid>
            </Box>
        </Link>
    );
};
